<template>
    <v-container >
        <v-card-text class="text--primary">{{text}}</v-card-text>        
    </v-container>    
</template>

<script>
    export default { 
        props: {        
            text: {
                type: String,
                required: true
            },
        }
    }
</script>